import React, { useState } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import classNames from 'classnames';
import SortAscendIcon from '../images/icons/sort-ascend.svg';
import arrowDown from '../images/icons/chevron-down.svg';

const SortOrder = props => {
    const { id, sortOptions, sortOrder, isMobile, onChange } = props;
    const [open, setOpen] = useState(false);

    const handleClick = (option) => {
        setOpen(!open);
        onChange('sortorder', option);
        let listingContainer = document.getElementById('listing-container');
        if (listingContainer)
            listingContainer.scrollTop = 0;
    }

    return <ButtonDropdown isOpen={open} toggle={() => setOpen(!open)} className="sort-order-container d-inline-flex">
        <DropdownToggle className="dyna-popoverText p-0" id={id} type="button" tag="button">
            <span>
                <img src={SortAscendIcon} alt="" className="pd-rt-5" />
                {sortOrder}
                <img src={arrowDown} alt="" className={classNames('pd-lft-5', { 'mg-rt-20': !isMobile })} />
            </span>
        </DropdownToggle>
        {sortOptions && sortOptions.length > 0 &&
            <DropdownMenu className="dyna-popoverBody dyna-popup-dropdown">
                {sortOptions.map((option, i) => {
                    return <DropdownItem key={i} className="dyna-item"
                        onClick={() => handleClick(option)}>{option}</DropdownItem>
                })}
            </DropdownMenu>
        }
    </ButtonDropdown>
}

export default SortOrder;